import * as React from 'react';
import Gateway from '../Gateway';
import { useTranslation } from 'react-i18next';
const Test = ({ onClick }) => {
    const { t } = useTranslation('PaymentForm');
    return React.createElement(Gateway, { header: t('Test payment'), onClick: onClick, paymentType: 'Test' });
};
export default Test;
